import t from 'tcomb';

const Purchase_State = t.enums.of('CANCELED PAID PENDING PROCESSING SHIPPED'.split(' '));

module.exports = Purchase_State;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Purchase_State.js
 **/